import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import type { ITableModelDefault } from 'shared/ui/TableNew'
import type { CallsAnalyticsKeys } from 'entities/Analytics/api/types'
import type { AnalyticsComparisonEntity } from 'pages/analytics/ui'

export interface ICallsComparisonData extends ITableModelDefault {
  id: string | number
  name: string
  metrics: Record<CallsAnalyticsKeys, number>
  breakdownEntity?: AnalyticsComparisonEntity
}

export class RowCallsComparison extends RowBase<ICallsComparisonData> {
  constructor(data: ICallsComparisonData) {
    super(data)

    makeObservableRowBase(this, {
      fields: computed,
    })
  }

  get fields() {
    return {
      name: this.origin.name,
      total: this.origin.metrics.total,
      outbound_calls: this.origin.metrics.outbound_calls,
      inbound_calls: this.origin.metrics.inbound_calls,
      avg_duration_outbound: this.origin.metrics.avg_duration_outbound,
      answered_outbound: this.origin.metrics.answered_outbound,
      unanswered_outbound: this.origin.metrics.unanswered_outbound,
      busy_outbound: this.origin.metrics.busy_outbound,
      failed_outbound: this.origin.metrics.failed_outbound,
      avg_duration_inbound: this.origin.metrics.avg_duration_inbound,
      answered_inbound_human: this.origin.metrics.answered_inbound_human,
      answered_inbound_ai: this.origin.metrics.answered_inbound_ai,
      missed_inbound: this.origin.metrics.missed_inbound,
      busy_inbound: this.origin.metrics.busy_inbound,
      failed_inbound: this.origin.metrics.failed_inbound,
      forwarded: this.origin.metrics.forwarded,
      avg_duration_forwarded: this.origin.metrics.avg_duration_forwarded,
      breakdownEntity: this.origin.breakdownEntity,
    }
  }
}
